import { ICandidateTimeline } from "@core/models";

export const offerTimelineMock = [
  {
    [ICandidateTimeline.date]: "2022-09-30",
    [ICandidateTimeline.status]: "success",
    [ICandidateTimeline.label]: "Tu as postulé",
  },
  {
    [ICandidateTimeline.status]: "warning",
    [ICandidateTimeline.label]: "En attente de la réponse de l'établissement",
  },
  {
    [ICandidateTimeline.status]: "default",
    [ICandidateTimeline.label]: "Début du job 🚀",
  },
];

export const KycTimelineMock = [
  {
    [ICandidateTimeline.date]: "2022-09-30",
    [ICandidateTimeline.status]: "success",
    [ICandidateTimeline.label]: "Tu es booké",
  },
  {
    [ICandidateTimeline.status]: "warning",
    [ICandidateTimeline.label]: "En attente d'activation",
  },
  {
    [ICandidateTimeline.status]: "default",
    [ICandidateTimeline.label]: "En attente de validation",
  },
  {
    [ICandidateTimeline.status]: "default",
    [ICandidateTimeline.label]: "Compte validé 🚀",
  },
];
